import _inject from "@stylexjs/stylex/lib/stylex-inject";
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
import React, { useContext, useEffect, useState } from 'react';
import PropTypes from "prop-types";
import { __get, __post } from "noood/net/xhr";
import FlexJustified from "../../ui/containers/flex-boxes/FlexJustified";
import SpinnerApple from "../../ui/spinner/Spinner.Apple";
import { FormContext } from 'noood/contexts/contexts';
import { form_validator } from "../FormFieldValidator";
import FlexHorizontalCenter from "../../ui/containers/flex-boxes/FlexHorizontalCenter";
import Feedback from "../../feedback/Feedback";
import Text from "../../text/Text";
import { ArrayUtil } from "noood/util/array/ArrayUtil";
import Icon from "../../ui/feather-icon/Icon";
import AddDropdownOptionForm from "noood/comp/form/dropdown/AddDropdownOptionForm";
import Spacer from "noood/comp/ui/spacer/Spacer";
import FlexCenter from "noood/comp/ui/containers/flex-boxes/FlexCenter";
import ImageViewer from "noood/comp/ui/image-viewer/ImageViewer";
import Flex from "noood/comp/ui/containers/Flex";
import * as stylex from '@stylexjs/stylex';
import { string_util } from "noood/util/string/StringUtil";
import { ClosestElementRegistryContext } from "noood/contexts/contexts";
import { styling } from "noood/styles/styles.stylex";
import { useClosestElementRegistry } from "noood/util/listener/ClosestElementRegistry";
var MAX_OPTION_HEIGHT = 250;
export default function Dropdown(props) {
  var _form_$formObj2, _props$label, _props$styling, _props$styling2, _props$styling3, _props$styling4, _props$placeholder, _props$styling5;
  var closestCtx = useContext(ClosestElementRegistryContext);
  var closest = useClosestElementRegistry(); // closestCtx ?? props.closestEltRegistryCtx;
  var form_ = useContext(FormContext);
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    opts = _useState2[0],
    set_opts = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    show_opts = _useState4[0],
    set_show_opts = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    chosen = _useState6[0],
    set_chosen = _useState6[1];
  var _useState7 = useState(),
    _useState8 = _slicedToArray(_useState7, 2),
    id = _useState8[0],
    set_id = _useState8[1];
  var _useState9 = useState(undefined),
    _useState0 = _slicedToArray(_useState9, 2),
    filter = _useState0[0],
    set_filter = _useState0[1];
  var _useState1 = useState(),
    _useState10 = _slicedToArray(_useState1, 2),
    key_selected = _useState10[0],
    set_key_selected = _useState10[1];
  var _useState11 = useState(),
    _useState12 = _slicedToArray(_useState11, 2),
    errors = _useState12[0],
    set_errors = _useState12[1];
  var _useState13 = useState(),
    _useState14 = _slicedToArray(_useState13, 2),
    cssForAnimations = _useState14[0],
    setCssForAnimations = _useState14[1];
  var _useState15 = useState(),
    _useState16 = _slicedToArray(_useState15, 2),
    isNudged = _useState16[0],
    setIsNudged = _useState16[1];
  var _useState17 = useState(),
    _useState18 = _slicedToArray(_useState17, 2),
    isFocused = _useState18[0],
    setIsFocused = _useState18[1];
  var _reshadeOptions = function _reshadeOptions() {
    var _select$getBoundingCl, _opts$getBoundingClie, _opts$getBoundingClie2;
    var opts = document.getElementById("dd-".concat(id));
    var select = document.getElementById("ui-dd-".concat(id));
    var childrenTotalHeight = Array.from(opts.children).reduce(function (prevVal, elt) {
      var _elt$getBoundingClien;
      return prevVal + ((_elt$getBoundingClien = elt.getBoundingClientRect()) === null || _elt$getBoundingClien === void 0 ? void 0 : _elt$getBoundingClien.height);
    }, 0);

    // check if the options floating window will overflow the browser viewport. if yes, reposition
    var selectHeight = (_select$getBoundingCl = select.getBoundingClientRect()) === null || _select$getBoundingCl === void 0 ? void 0 : _select$getBoundingCl.height;
    var optionFloaterYPos = ((_opts$getBoundingClie = opts.getBoundingClientRect()) === null || _opts$getBoundingClie === void 0 ? void 0 : _opts$getBoundingClie.y) + ((_opts$getBoundingClie2 = opts.getBoundingClientRect()) === null || _opts$getBoundingClie2 === void 0 ? void 0 : _opts$getBoundingClie2.height) + 1;
    var childrenTotalHeightScrollable = childrenTotalHeight > MAX_OPTION_HEIGHT ? MAX_OPTION_HEIGHT : childrenTotalHeight;
    var floated = optionFloaterYPos + childrenTotalHeightScrollable;
    var currentWindowHeight = window.innerHeight;
    var nudge = 0;
    if (floated > currentWindowHeight) {
      // reposition
      nudge = (selectHeight + childrenTotalHeightScrollable + 1) * -1;
      setIsNudged(true);
    } else {
      setIsNudged(false);
    }
    setCssForAnimations({
      height: "".concat((childrenTotalHeight > MAX_OPTION_HEIGHT ? MAX_OPTION_HEIGHT : childrenTotalHeight) + 1, "px"),
      borderTop: nudge >= 0 ? "1px solid var(--shade-dark)" : "",
      borderBottomLeftRadius: nudge >= 0 ? "var(--roundness)" : 0,
      borderBottomRightRadius: nudge >= 0 ? "var(--roundness)" : 0,
      marginTop: "".concat(nudge, "px"),
      borderBottom: nudge < 0 ? '1px solid var(--shade-dark)' : "",
      borderTopLeftRadius: nudge < 0 ? "var(--roundness)" : 0,
      borderTopRightRadius: nudge < 0 ? "var(--roundness)" : 0
    });
  };
  var _hideOptions = function _hideOptions() {
    setCssForAnimations({
      height: "0"
    });
  };
  useEffect(function () {
    if (show_opts) {
      _reshadeOptions();
    }
  }, [opts]);
  useEffect(function () {
    if (form_ !== null && form_ !== void 0 && form_.formObj && (opts === null || opts === void 0 ? void 0 : opts.length) > 0) {
      var theChosen = ArrayUtil.id_is(opts, 'value', form_.formObj[props.name]);
      set_chosen(theChosen);
    }
  }, [opts === null || opts === void 0 ? void 0 : opts.length]);
  useEffect(function () {
    set_id(props.id);
  }, [props.id]);

  /*useEffect(() => {
   if (id && closest) {
   closest.__register(`#dd-${id}`, () => {
   set_show_opts(false);
   setIsNudged(false);
   _hideOptions();
   })
   }
   }, [id, closest])*/

  // useEffect(() => {
  //   console.log(`>>>>>>>>>>>>>>>>>>>>>>>`)
  //   if (form_.formObj?.[props.name]) {
  //     set_chosen(ArrayUtil.id_is(opts, "value", form_.formObj?.[props.name]))
  //   }
  //   // props.__opts?.(opts)
  // }, [opts])

  useEffect(function () {
    if (!show_opts) {
      set_key_selected(undefined);
    } else {
      _reshadeOptions();
    }
  }, [show_opts]);
  useEffect(function () {
    if (chosen) {
      var _form_$__collect, _props$__collect;
      var _errors = form_validator.validate(props.validations, chosen === null || chosen === void 0 ? void 0 : chosen.value);
      form_ === null || form_ === void 0 || (_form_$__collect = form_.__collect) === null || _form_$__collect === void 0 || _form_$__collect.call(form_, props.name, chosen === null || chosen === void 0 ? void 0 : chosen.value, _errors);
      (_props$__collect = props.__collect) === null || _props$__collect === void 0 || _props$__collect.call(props, chosen === null || chosen === void 0 ? void 0 : chosen.value);
      set_errors(_errors);
    }
  }, [chosen]);
  useEffect(function () {
    var _form_$formObj;
    var form_value = form_ === null || form_ === void 0 || (_form_$formObj = form_.formObj) === null || _form_$formObj === void 0 ? void 0 : _form_$formObj[props.name];
    if (form_value && (opts === null || opts === void 0 ? void 0 : opts.length) > 0) {
      set_chosen(opts.find(function (option) {
        var _option$value;
        return ((_option$value = option.value) === null || _option$value === void 0 ? void 0 : _option$value.toString()) === (form_value === null || form_value === void 0 ? void 0 : form_value.toString());
      }));
    } else {
      set_chosen(undefined);
    }
  }, [form_ === null || form_ === void 0 || (_form_$formObj2 = form_.formObj) === null || _form_$formObj2 === void 0 ? void 0 : _form_$formObj2[props.name]]);
  useEffect(function () {
    if ((opts === null || opts === void 0 ? void 0 : opts.length) > 0 && props.value) {
      set_chosen(opts.find(function (option) {
        var _option$value2, _props$value;
        return ((_option$value2 = option.value) === null || _option$value2 === void 0 ? void 0 : _option$value2.toString()) === ((_props$value = props.value) === null || _props$value === void 0 ? void 0 : _props$value.toString());
      }));
    } else {
      if (props.value === void 0) {
        // console.log(`you just removed the value from this `)
      }
    }
  }, [props.value, opts]);
  useEffect(function () {
    if (props.data_source) {
      if (ArrayUtil.is(props.data_source)) {
        set_opts(props.data_source);
        // _reshadeOptions();
      } else {
        __get("".concat(props.data_source), {}, function (res) {
          var _res$http;
          if ((res === null || res === void 0 || (_res$http = res.http) === null || _res$http === void 0 ? void 0 : _res$http.code) === 200 && res.data) {
            set_opts(res.data);
            // _reshadeOptions();
          }
        });
      }
    }
  }, [props.data_source]);
  var __filtered = function __filtered() {
    return opts.filter(function (opt) {
      var _opt$code, _opt$description;
      var ok = ((_opt$code = opt.code) === null || _opt$code === void 0 ? void 0 : _opt$code.toLowerCase().match(filter === null || filter === void 0 ? void 0 : filter.toLowerCase())) || ((_opt$description = opt.description) === null || _opt$description === void 0 ? void 0 : _opt$description.toLowerCase().match(filter === null || filter === void 0 ? void 0 : filter.toLowerCase()));
      return ok;
    });
  };
  var addOption = function addOption() {
    var _props$add_url;
    if (((_props$add_url = props.add_url) === null || _props$add_url === void 0 ? void 0 : _props$add_url.length) > 0) {
      // xhr to post this new option, then add to the list of options
      // by calling props.__add
      var payload = {};
      payload[props.code_field] = filter;
      payload = _objectSpread(_objectSpread({}, payload), props.add_body_data);
      __post(props.add_url, {
        body: JSON.stringify(payload)
      }, function (res) {
        var _res$http2, _res$data;
        if ((res === null || res === void 0 || (_res$http2 = res.http) === null || _res$http2 === void 0 ? void 0 : _res$http2.code) === 200 && (_res$data = res.data) !== null && _res$data !== void 0 && _res$data[props.responseDataProperty]) {
          var _res$data2, _props$__add, _form_$__collect2;
          var newOption = {
            value: (_res$data2 = res.data) === null || _res$data2 === void 0 || (_res$data2 = _res$data2[props.responseDataProperty]) === null || _res$data2 === void 0 ? void 0 : _res$data2.id,
            code: filter
          };
          // if (props.__add) {
          //   props.__add(newOption);
          // } else {
          //   set_opts([...opts, newOption])
          // }
          (_props$__add = props.__add) === null || _props$__add === void 0 || _props$__add.call(props, newOption);
          set_opts([].concat(_toConsumableArray(opts), [newOption]));
          set_chosen(newOption);
          set_filter(undefined);
          form_ === null || form_ === void 0 || (_form_$__collect2 = form_.__collect) === null || _form_$__collect2 === void 0 || _form_$__collect2.call(form_, props.name, newOption.value, []);
        }
      });
    } else {
      // save in the state array
    }
  };
  var isRequired = ArrayUtil["in"](props.validations, "required");
  var disabled = props.disabled;
  var bgColor = disabled ? '#cbcbcb' : isRequired ? '#fff8db' : '#f7f7f7';
  var textColor = disabled ? '#aaa' : "var(--text-on-shade)";
  var derivedLabel = (_props$label = props.label) !== null && _props$label !== void 0 ? _props$label : !props.nolabel && !props.placeholder && string_util.uc_words(props.name, "_");
  return /*#__PURE__*/React.createElement("div", null, derivedLabel && /*#__PURE__*/React.createElement("span", {
    className: "text-label"
  }, derivedLabel, isRequired ? " *" : ""), /*#__PURE__*/React.createElement("div", _extends({
    id: "ui-dd-".concat(id),
    onFocusCapture: function onFocusCapture(e) {},
    style: _objectSpread({
      justifyContent: "flex-end",
      height: props.height ? "".concat(props.height, "px") : undefined
    }, (_props$styling = props.styling) === null || _props$styling === void 0 ? void 0 : _props$styling.row),
    tabIndex: 0
  }, stylex.props(ui.container, isRequired && ui.required, props.disabled && ui.disabled, isNudged && ui.nudged, show_opts && !isNudged && ui.optionsShown, isFocused && styling.focusRing)), props.icon && /*#__PURE__*/React.createElement(FlexCenter, {
    className: "ui-dd-icon",
    style: {
      paddingLeft: "5px"
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: props.icon,
    style: {
      color: "".concat(props.disabled ? 'var(--shade-20)' : "var(--shade-80)")
    }
  })), /*#__PURE__*/React.createElement(FlexHorizontalCenter, {
    className: "ui-dd-chosen",
    style: _objectSpread({
      width: "100%",
      paddingLeft: "10px"
    }, (_props$styling2 = props.styling) === null || _props$styling2 === void 0 ? void 0 : _props$styling2.chosenBox),
    onClick: function onClick() {
      if (!props.disabled) {
        set_show_opts(true);
      }
    }
  }, show_opts ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", _extends({
    onChange: function onChange(e) {
      set_filter(e.target.value);
    },
    value: filter,
    id: "dd-filter-".concat(id),
    autoFocus: true,
    onFocus: function onFocus() {
      setIsFocused(true);
    },
    onBlur: function onBlur() {
      setIsFocused(false);
    },
    style: {
      padding: 0,
      fontSize: "15px",
      color: "var(--shade-80)"
    },
    onKeyUp: function onKeyUp(e) {
      var _opts$filter;
      // console.log(e)
      var filtered = opts === null || opts === void 0 || (_opts$filter = opts.filter) === null || _opts$filter === void 0 ? void 0 : _opts$filter.call(opts, function (opt) {
        var _opt$code2, _opt$description2;
        return ((_opt$code2 = opt.code) === null || _opt$code2 === void 0 ? void 0 : _opt$code2.toLowerCase().match(filter === null || filter === void 0 ? void 0 : filter.toLowerCase())) || ((_opt$description2 = opt.description) === null || _opt$description2 === void 0 ? void 0 : _opt$description2.toLowerCase().match(filter === null || filter === void 0 ? void 0 : filter.toLowerCase()));
      });
      if (e.code === "ArrowDown") {
        if (key_selected === void 0) {
          set_key_selected(0);
        } else {
          var new_index = Number(key_selected) + 1;
          if (new_index > filtered.length - 1) {
            new_index = 0;
          }
          set_key_selected(new_index);
        }
      } else if (e.code === "ArrowUp") {
        if (key_selected === void 0) {
          set_key_selected(filtered.length - 1);
        } else {
          var _new_index = Number(key_selected) - 1;
          if (_new_index < 0) {
            _new_index = filtered.length - 1;
          }
          set_key_selected(_new_index);
        }
      } else if (e.code === "Enter") {
        if (e.preventDefault) {
          e.preventDefault();
          if (key_selected) {
            set_show_opts(false);
            setIsNudged(false);
            set_chosen(filtered[key_selected]);
            set_filter(undefined);
          } else {
            if (filter) {
              addOption();
            }
          }
        }
      } else if (e.code === "Escape") {
        set_show_opts(false);
        set_filter(undefined);
      }
      _reshadeOptions();
    }
  }, {
    className: "Dropdown__ui.filterTextfield evjbqb8w ev1a2a7pz evc342km evha96y3 ev71xlcl evh8yej3"
  }))) : /*#__PURE__*/React.createElement(Flex, {
    style: {
      flexShrink: 0
    }
  }, /*#__PURE__*/React.createElement(React.Fragment, null, opts ? /*#__PURE__*/React.createElement(React.Fragment, null, chosen ? /*#__PURE__*/React.createElement("span", {
    style: _objectSpread({
      color: disabled ? 'var(--shade-10)' : 'var(--shade-80)'
    }, (_props$styling3 = props.styling) === null || _props$styling3 === void 0 ? void 0 : _props$styling3.chosenText)
  }, chosen.code) : /*#__PURE__*/React.createElement("div", {
    style: _objectSpread(_objectSpread({
      color: disabled ? 'var(--shade-10)' : '#727272'
    }, (_props$styling4 = props.styling) === null || _props$styling4 === void 0 ? void 0 : _props$styling4.chosenText), {}, {
      display: 'flex'
    })
  }, /*#__PURE__*/React.createElement("div", stylex.props(ui.chooseOption, props.disabled && ui.chooseOptionDisabled), (_props$placeholder = props.placeholder) !== null && _props$placeholder !== void 0 ? _props$placeholder : "Choose an option"))) : 'Fetching options...'))), chosen && !props.disabled && /*#__PURE__*/React.createElement(FlexCenter, {
    className: {
      className: "Dropdown__ui.clearButton ev1h2kqdt evcpk43y ev1nx2rwh ev1ypdohk ev3dtjww ev12p33jh"
    }.className,
    onClick: function onClick() {
      if (props._onBeforeClear) {
        props._onBeforeClear(function (doClear) {
          if (doClear) {
            var _props$__collect2, _props$onDemand, _form_$__collect3;
            set_chosen(undefined);
            set_filter(undefined);
            var _errors2 = form_validator.validate(props.validations, undefined);
            set_errors(_errors2);
            (_props$__collect2 = props.__collect) === null || _props$__collect2 === void 0 || _props$__collect2.call(props, undefined);
            (_props$onDemand = props.onDemand) === null || _props$onDemand === void 0 || _props$onDemand.call(props, undefined);
            form_ === null || form_ === void 0 || (_form_$__collect3 = form_.__collect) === null || _form_$__collect3 === void 0 || _form_$__collect3.call(form_, props.name, undefined, _errors2);
          }
        });
      } else {
        var _props$__collect3, _props$onDemand2, _form_$__collect4;
        set_chosen(undefined);
        set_filter(undefined);
        var _errors3 = form_validator.validate(props.validations, undefined);
        set_errors(_errors3);
        (_props$__collect3 = props.__collect) === null || _props$__collect3 === void 0 || _props$__collect3.call(props, undefined);
        (_props$onDemand2 = props.onDemand) === null || _props$onDemand2 === void 0 || _props$onDemand2.call(props, undefined);
        form_ === null || form_ === void 0 || (_form_$__collect4 = form_.__collect) === null || _form_$__collect4 === void 0 || _form_$__collect4.call(form_, props.name, undefined, _errors3);
      }
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: 'x',
    color: disabled ? 'var(--shade-10)' : 'var(--shade-60)'
  })), /*#__PURE__*/React.createElement(FlexCenter, {
    style: _objectSpread({
      width: "30px",
      justifyContent: "center",
      borderTopRightRadius: isNudged ? 0 : "var(--roundness)",
      borderBottomRightRadius: show_opts ? isNudged ? "var(--roundness)" : 0 : "var(--roundness)"
    }, (_props$styling5 = props.styling) === null || _props$styling5 === void 0 ? void 0 : _props$styling5.chooseButton),
    onClick: function onClick() {
      if (!props.disabled) {
        closest.__register("#dd-".concat(id), function () {
          set_show_opts(false);
          setIsNudged(false);
          _hideOptions();
        });
        set_show_opts(!show_opts);
      }
    },
    className: stylex.props(ui.arrowDownButton, isRequired && ui.requiredArrowDownButton, disabled && ui.disabledArrowDownButton).className
  }, opts ? /*#__PURE__*/React.createElement(React.Fragment, null, props.isLoading ? /*#__PURE__*/React.createElement(SpinnerApple, null) : /*#__PURE__*/React.createElement(Icon, {
    icon: 'chevron-down',
    stylexStyles: [isRequired && ui.requiredDropdownChevron, props.disabled && ui.requiredDropdownChevronDisabled],
    useStyle: false
  })) : /*#__PURE__*/React.createElement(SpinnerApple, null))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      zIndex: 2
    }
  }, /*#__PURE__*/React.createElement("div", _extends({
    id: "dd-".concat(id)
  }, stylex.props(ui.options_box, show_opts && ui.options_are_shown, isNudged && ui.nudged), {
    style: _objectSpread({}, cssForAnimations)
  }), (filter === null || filter === void 0 ? void 0 : filter.length) > 0 && props.allow_add && (opts === null || opts === void 0 ? void 0 : opts.length) > 0 && !ArrayUtil.id_is(opts, "code", filter) && /*#__PURE__*/React.createElement(AddDropdownOptionForm, {
    code: filter
  }), (opts === null || opts === void 0 ? void 0 : opts.length) > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, __filtered().map(function (opt, idx) {
    var _opt$value, _chosen$value, _opt$value2, _chosen$value2;
    var is_chosen = ((_opt$value = opt.value) === null || _opt$value === void 0 ? void 0 : _opt$value.toString()) === (chosen === null || chosen === void 0 || (_chosen$value = chosen.value) === null || _chosen$value === void 0 ? void 0 : _chosen$value.toString());
    return /*#__PURE__*/React.createElement("div", _extends({
      className: ["ui-dd-opt", idx === key_selected ? 'ui-dd-opt-focus' : undefined].join(' '),
      key: idx,
      style: {
        padding: "5px 15px 5px 5px"
      },
      onClick: function onClick() {
        var _props$onDemand3;
        set_chosen(opt);
        set_show_opts(false);
        set_filter(undefined);
        setIsNudged(false);
        _hideOptions();
        (_props$onDemand3 = props.onDemand) === null || _props$onDemand3 === void 0 || _props$onDemand3.call(props, opt.value);
      }
    }, stylex.props(ui.option, isFocused && ui.optionFocused, is_chosen && ui.chosen)), /*#__PURE__*/React.createElement(FlexJustified, {
      row_gap: 7
    }, opt.icon && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
      icon: opt.icon,
      color: "var(--text-color)"
    })), props.showImage && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ImageViewer, {
      filename: opt.img,
      size: 20
    })), /*#__PURE__*/React.createElement("div", _extends({
      style: {
        width: '100%'
      }
    }, stylex.props(ui.option_label, is_chosen && ui.chosen_label)), opt.code), ((_opt$value2 = opt.value) === null || _opt$value2 === void 0 ? void 0 : _opt$value2.toString()) === (chosen === null || chosen === void 0 || (_chosen$value2 = chosen.value) === null || _chosen$value2 === void 0 ? void 0 : _chosen$value2.toString()) && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
      icon: "check",
      color: "var(--text-success)"
    }))));
  }), __filtered().length === 0 && /*#__PURE__*/React.createElement(FlexJustified, {
    style: {}
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: "100%",
      textAlign: "center",
      padding: "20px"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-secondary text-S"
  }, "No match for ", filter)))) : /*#__PURE__*/React.createElement(FlexCenter, {
    style: {
      backgroundColor: "var(--shade-light)"
    }
  }, props.allow_add ? /*#__PURE__*/React.createElement(React.Fragment, null, (filter === null || filter === void 0 ? void 0 : filter.length) > 0 ? /*#__PURE__*/React.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React.createElement(AddDropdownOptionForm, {
    code: filter,
    __submit: function __submit() {}
  })) : /*#__PURE__*/React.createElement("div", {
    style: {
      padding: "10px"
    }
  }, "Type to add a new ", props.label)) : /*#__PURE__*/React.createElement("div", {
    style: {
      paddingTop: "20px",
      paddingBottom: "20px"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-secondary"
  }, "There are no options ", filter && "to filter"))))), props.caption && /*#__PURE__*/React.createElement(Text, {
    secondary: true
  }, props.caption), (errors === null || errors === void 0 ? void 0 : errors.length) > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, {
    mtop: 5
  }), errors === null || errors === void 0 ? void 0 : errors.map(function (err, idx) {
    return /*#__PURE__*/React.createElement(Feedback, {
      errors: errors,
      key: "feedback-item-".concat(idx)
    });
  })), props.spacer && /*#__PURE__*/React.createElement(Spacer, {
    mtop: props.spacer
  }));
}
Dropdown.propTypes = {
  icon: PropTypes.string,
  data_source: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({
    code: PropTypes.string,
    value: PropTypes.any,
    description: PropTypes.string,
    icon: PropTypes.string
  })), PropTypes.string]),
  allow_add: PropTypes.bool,
  id: PropTypes.string.isRequired,
  validations: PropTypes.array,
  label: PropTypes.string,
  spacer: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  __opts: PropTypes.func,
  // when the list of options changes, inform using this function
  __add: PropTypes.func,
  /* the URL receiving the POST data when an add operation is initiated.
   If no URL is provided, the new option will only reside in the state array */
  add_url: PropTypes.string,
  /* Upon POST request, this props will be merged with the POST body */
  add_body_data: PropTypes.object,
  /* What is the "code" column of the original table */
  code_field: PropTypes.string,
  caption: PropTypes.string,
  __collect: PropTypes.func
  //the xhr should response with a structure of {{...}, {data:{id:<ID>,responseDataProperty:{<OBJ>}}, {...}}}
  ,

  responseDataProperty: PropTypes.string,
  disabled: PropTypes.bool,
  height: PropTypes.number // the over-all height of the dropdown (not including the label)
  ,

  closestEltRegistryCtx: PropTypes.element,
  onDemand: PropTypes.func,
  name: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
  styling: PropTypes.shape({
    chosenText: PropTypes.object,
    chosenBox: PropTypes.object,
    row: PropTypes.object,
    chooseButton: PropTypes.object
  }),
  placeholder: PropTypes.string
  // before effecting the clearing of the value of the dropdown when clicking the x button
  ,

  _onBeforeClear: PropTypes.func,
  showImage: PropTypes.bool,
  nolabel: PropTypes.bool // do not show label (or derive from placeholder or "name")
};
Dropdown.defaultProps = {
  spacer: 8,
  showImage: false
};

// @ts-ignore
_inject(".evxwrc4x{border-radius:var(--roundness)}", 2000);
_inject(".ev1tgzv6z{height:var(--field-height)}", 4000);
_inject(".ev78zum5{display:flex}", 3000);
_inject(".ev1qjc9v5{align-items:stretch}", 3000);
_inject(".ev70fga0{background-color:var(--shade-field)}", 3000);
_inject(".evmkeg23{border-width:1px}", 2000);
_inject(".ev1y0btm7{border-style:solid}", 2000);
_inject(".ev4745u8{border-color:var(--shade-10)}", 2000);
_inject(".ev1lko15j{background-color:var(--shade-required)}", 3000);
_inject(".evsqfd0d{border-color:var(--shade-20)}", 2000);
_inject(".ev1g19nhj{color:var(--shade-05)}", 3000);
_inject(".evji57aj{background-color:var(--shade-10)}", 3000);
_inject(".evgih7pf{border-color:var(--shade-05)}", 2000);
_inject(".ev1h6gzvc{cursor:not-allowed}", 3000);
_inject(".ev1h2kqdt{transition:background-color .2s}", 2000);
_inject(".ev1kd3s2o{background-color:var(--shade-20)}", 3000);
_inject(".evt6t3nb{background-color:var(--shade-required-dark)}", 3000);
_inject(".evvlbeop:hover{background-color:var(--shade-required-darker)}", 3130);
_inject(".evc36ahu:active{background-color:var(--shade-required-darkest)}", 3170);
_inject(".eve0pwq{border-left-width:1px}", 4000);
_inject(".ev1fl4ca7{border-left-color:var(--shade-20)}", 4000);
_inject(".ev19ypqd9{border-left-style:solid}", 4000);
_inject(".ev1blgh98{color:var(--shade-40)}", 3000);
_inject(".ev1y7ric0{background-color:var(--shade-05)}", 3000);
_inject(".evcpk43y{padding-left:5px}", 4000);
_inject(".ev1nx2rwh{padding-right:5px}", 4000);
_inject(".ev1ypdohk{cursor:pointer}", 3000);
_inject(".ev3dtjww:hover{background-color:var(--shade-10)}", 3130);
_inject(".ev12p33jh:active{background-color:var(--shade-15)}", 3170);
_inject(".ev1ia1hqs{border-top-left-radius:0}", 4000);
_inject(".ev1a2w583{border-top-right-radius:0}", 4000);
_inject(".evfrllxf{border-bottom-left-radius:0}", 4000);
_inject(".evjppbhk{border-bottom-right-radius:0}", 4000);
_inject(".evjbqb8w{background-color:transparent}", 3000);
_inject(".ev1a2a7pz{outline:none}", 2000);
_inject(".evc342km{border-width:0}", 2000);
_inject(".evha96y3{border-style:dotted}", 2000);
_inject(".ev71xlcl{border-color:red}", 2000);
_inject(".evh8yej3{width:100%}", 4000);
_inject(".ev1m3phxg{transition:background-color .1s}", 2000);
_inject(".ev1klv73h{background-color:var(--shade-dark)}", 3000);
_inject(".ev17fxeyu:hover{background-color:var(--shade)}", 3130);
_inject(".ev972fbf{border-top-width:0}", 3000);
_inject(".ev17e5z5g{color:var(--text-color)}", 3000);
_inject(".ev1jo8pe8{color:var(--shade-30)}", 3000);
_inject(".ev10l6tqk{position:absolute}", 3000);
_inject(".ev1s85apg{display:none}", 3000);
_inject(".ev11ycvst{background-color:var(--shade)}", 3000);
_inject(".evl8z2ie{max-height:250px}", 4000);
_inject(".evsvbl62{overflow-x:none}", 4000);
_inject(".ev1odjw0f{overflow-y:auto}", 4000);
_inject(".ev1lliihq{display:block}", 3000);
var ui = {
  container: {
    "Dropdown__ui.container": "Dropdown__ui.container",
    borderRadius: "evxwrc4x",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    height: "ev1tgzv6z",
    display: "ev78zum5",
    alignItems: "ev1qjc9v5",
    backgroundColor: "ev70fga0",
    borderWidth: "evmkeg23",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: "ev1y0btm7",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: "ev4745u8",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    $$css: true
  },
  required: {
    "Dropdown__ui.required": "Dropdown__ui.required",
    backgroundColor: "ev1lko15j",
    borderWidth: "evmkeg23",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: "ev1y0btm7",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: "evsqfd0d",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    $$css: true
  },
  disabled: {
    "Dropdown__ui.disabled": "Dropdown__ui.disabled",
    backgroundColor: "evji57aj",
    borderWidth: "evmkeg23",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: "ev1y0btm7",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: "evgih7pf",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    cursor: "ev1h6gzvc",
    $$css: true
  },
  arrowDownButton: {
    "Dropdown__ui.arrowDownButton": "Dropdown__ui.arrowDownButton",
    transition: "ev1h2kqdt",
    transitionBehavior: null,
    transitionDelay: null,
    transitionDuration: null,
    transitionProperty: null,
    transitionTimingFunction: null,
    backgroundColor: "ev1kd3s2o",
    $$css: true
  },
  requiredArrowDownButton: {
    "Dropdown__ui.requiredArrowDownButton": "Dropdown__ui.requiredArrowDownButton",
    backgroundColor: "evt6t3nb evvlbeop evc36ahu",
    borderLeftWidth: "eve0pwq",
    borderInlineStartWidth: null,
    borderInlineEndWidth: null,
    borderLeftColor: "ev1fl4ca7",
    borderInlineStartColor: null,
    borderInlineEndColor: null,
    borderLeftStyle: "ev19ypqd9",
    borderInlineStartStyle: null,
    borderInlineEndStyle: null,
    $$css: true
  },
  requiredDropdownChevron: {
    "Dropdown__ui.requiredDropdownChevron": "Dropdown__ui.requiredDropdownChevron",
    color: "ev1blgh98",
    $$css: true
  },
  requiredDropdownChevronDisabled: {
    "Dropdown__ui.requiredDropdownChevronDisabled": "Dropdown__ui.requiredDropdownChevronDisabled",
    color: "ev1g19nhj",
    $$css: true
  },
  disabledArrowDownButton: {
    "Dropdown__ui.disabledArrowDownButton": "Dropdown__ui.disabledArrowDownButton",
    backgroundColor: "ev1y7ric0",
    borderColor: "evgih7pf",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    $$css: true
  },
  nudged: {
    "Dropdown__ui.nudged": "Dropdown__ui.nudged",
    borderTopLeftRadius: "ev1ia1hqs",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderTopRightRadius: "ev1a2w583",
    $$css: true
  },
  optionsShown: {
    "Dropdown__ui.optionsShown": "Dropdown__ui.optionsShown",
    borderBottomLeftRadius: "evfrllxf",
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderBottomRightRadius: "evjppbhk",
    $$css: true
  },
  option: {
    "Dropdown__ui.option": "Dropdown__ui.option",
    cursor: "ev1ypdohk",
    transition: "ev1m3phxg",
    transitionBehavior: null,
    transitionDelay: null,
    transitionDuration: null,
    transitionProperty: null,
    transitionTimingFunction: null,
    backgroundColor: "ev1klv73h ev17fxeyu",
    borderWidth: "evmkeg23",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: "ev972fbf",
    borderBottomWidth: null,
    borderStyle: "ev1y0btm7",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: "evgih7pf",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    $$css: true
  },
  chosen: {
    "Dropdown__ui.chosen": "Dropdown__ui.chosen",
    backgroundColor: "evji57aj",
    $$css: true
  },
  chosen_label: {
    "Dropdown__ui.chosen_label": "Dropdown__ui.chosen_label",
    color: "ev17e5z5g",
    $$css: true
  },
  chooseOption: {
    "Dropdown__ui.chooseOption": "Dropdown__ui.chooseOption",
    color: "ev1jo8pe8",
    $$css: true
  },
  chooseOptionDisabled: {
    "Dropdown__ui.chooseOptionDisabled": "Dropdown__ui.chooseOptionDisabled",
    color: "ev1g19nhj",
    $$css: true
  },
  optionFocused: {
    "Dropdown__ui.optionFocused": "Dropdown__ui.optionFocused",
    $$css: true
  },
  options_box: {
    "Dropdown__ui.options_box": "Dropdown__ui.options_box",
    position: "ev10l6tqk",
    width: "evh8yej3",
    display: "ev1s85apg",
    backgroundColor: "ev11ycvst",
    borderWidth: "evmkeg23",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: "ev1y0btm7",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: "evsqfd0d",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    maxHeight: "evl8z2ie",
    overflowX: "evsvbl62",
    overflowY: "ev1odjw0f",
    $$css: true
  },
  options_are_shown: {
    "Dropdown__ui.options_are_shown": "Dropdown__ui.options_are_shown",
    display: "ev1lliihq",
    $$css: true
  }
};